export const TILE_RES = 240;
export const TILE_FIT: [number, number] = [TILE_RES, TILE_RES];

export const THUMB_RES = 60;
export const THUMB_FIT: [number, number] = [THUMB_RES, THUMB_RES];
